module.exports = __webpack_public_path__ + "b44b355c7a400215eb6ad3bdbd0e9306.MP3";